import { oliveElevationTokens } from '@ds/tokens'

const tokens = {
  low: oliveElevationTokens.elevationLow,
  medium: oliveElevationTokens.elevationMedium,
  highest: oliveElevationTokens.elevationHighest,
} as const

export default tokens
